import { UnitType } from '@racemap/utilities/types/units';
import { useCurrentEvent } from './useCurrentEvent';

export function useUnitType(): UnitType {
  const currentEvent = useCurrentEvent();
  return currentEvent?.playerOptions.unitType || UnitType.METRIC;
}
